var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDruk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.3 35.3",
    style: {
      enableBackground: "new 0 0 35.3 35.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#33ADA3;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F28F39;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E8553F;stroke-width:1.35;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#E8553F;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,13.7c0.9,1.9,2.2,5,3,5.8c0.8,0.8,2,0.8,2.8,0c0.8-0.8,0.8-2,0-2.8C19.2,15.8,16.1,14.5,14.2,13.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17.6,
    cy: 17.6,
    r: 15.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.6,
    y1: 4.9,
    x2: 17.6,
    y2: 7.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.6,
    y1: 8.6,
    x2: 10.4,
    y2: 10.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.9,
    y1: 17.6,
    x2: 7.3,
    y2: 17.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.6,
    y1: 26.7,
    x2: 10.4,
    y2: 24.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.4,
    y1: 29.2,
    x2: 18.9,
    y2: 29.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.4,
    y1: 26.7,
    x2: 18.9,
    y2: 26.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26.7,
    y1: 26.7,
    x2: 24.9,
    y2: 24.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.4,
    y1: 17.6,
    x2: 27.9,
    y2: 17.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26.7,
    y1: 8.6,
    x2: 24.9,
    y2: 10.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDruk);
export default __webpack_public_path__ + "static/media/druk.9c2eb3c65db712c2568bdeaa1681809b.svg";
export { ForwardRef as ReactComponent };